module.exports = __webpack_public_path__ + "static/media/gym.8f739351.jpg";